import { frameCount, numberOfChannels, type PcmAudio } from "../types";

export function toAudioBuffer(audio: PcmAudio): AudioBuffer {
  const frames = frameCount(audio);
  const channels = numberOfChannels(audio);
  if (frames === 0 || channels === 0) {
    throw new Error("Audio is empty.");
  }

  const buffer = new AudioBuffer({
    length: frames,
    numberOfChannels: channels,
    sampleRate: audio.sampleRate,
  });
  for (let c = 0; c < channels; c++) {
    const channel = audio.channelData[c];
    if (channel) buffer.copyToChannel(channel as Float32Array<ArrayBuffer>, c);
  }
  return buffer;
}
